import { useContext, useMemo } from "react";
import { AuthContext } from "./authContext/AuthContext";
import _ from "lodash";

function Permission(props) {
  const { auth } = useContext(AuthContext)

  const authResult = useMemo(() => auth, [auth]);

  const permissions = authResult?.user?.permissions;
  const roles = authResult?.user?.roles || [];

  let permissionMatch = false;

  // Dois modos de operação: individual e coletivo
  // individual: passa a permissão e a entidade como propriedades separadas ("create" e "renter")
  // coletivo: passa a permissão e a entidade juntas ("create:renter")
  // Criado para quando o componente a ser configurado funciona para todas as entidades juntas
  if (props.permission && props.entity) {
    permissionMatch = _.includes(
      permissions,
      `${props.permission}:${props.entity}`
    );
  } else if (props.permission) {
    permissionMatch = _.includes(permissions, props.permission);
  } else {
    // Se não especificou permissão, considere como true para os casos onde só queremos verificar role
    permissionMatch = !props.permission;
  }

  // Verificar role
  let roleMatch = false;
  if (props.role) {
    roleMatch = _.includes(roles, props.role);
  } else {
    // Se não especificou role, considere como true para os casos onde só queremos verificar permissão
    roleMatch = !props.role;
  }


  const match = permissionMatch && roleMatch;

  return (
    <>
      {match && (props.children)}
    </>
  )
}

export default Permission;
